import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./index.scss";

import ProductCard from "../../ProductCard";
import ProductService from "../../../services/product";
import { useNavigate } from "react-router-dom";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";

export const DisponibleSection = () => {
  const sliderRef = useRef(null);
  const productService = new ProductService();
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const loadProducts = async () => {
    setIsLoading(true);
    try {
      const response = await productService.getBientotDispo();
      setProducts(
        Array.isArray(response.data) ? response.data : response.data?.data || []
      );
    } catch (error) {
      showErrorToaster("Erreur lors du chargement des produits");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadProducts();
  }, []);
  const handleResize = () => {
    const width = window.innerWidth;
    if (width <= 480) setSlidesToShow(1);
    else if (width <= 768) setSlidesToShow(2);
    else if (width <= 1300) setSlidesToShow(2);
    else setSlidesToShow(3);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow, // dynamique
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    pauseOnHover: true,
  };

  return (
    <div className="temoignage-home">
      <div className="row justify-content-center">
        <div className="col-lg-3 mb-4">
          <div className="temoignage-home-title">Bientôt disponible</div>
          <div className="temoignage-home-text">
            Découvrez en avant-première nos prochaines nouveautés Alma Secret.
            Des soins uniques, toujours naturels et innovants, bientôt
            disponibles en Tunisie. Restez connectés !
          </div>

          <div className="slider-buttons mt-5 mb-3 d-flex">
            <button
              onClick={() => sliderRef.current.slickPrev()}
              className="prev-btn me-2">
              {/* SVG flèche gauche */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none">
                <path
                  d="M8.77252 5.93579L3.20836 11.5L8.77252 17.0641"
                  stroke="#5B8C51"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M18.7917 11.5L3.36419 11.5"
                  stroke="#5B8C51"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              onClick={() => sliderRef.current.slickNext()}
              className="next-btn">
              {/* SVG flèche droite */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none">
                <path
                  d="M13.2608 17.0642L18.825 11.5L13.2608 5.93588"
                  stroke="#5B8C51"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.24164 11.5H18.6691"
                  stroke="#5B8C51"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="col-lg-9">
          <Slider {...settings} ref={sliderRef}>
            {products.map((product) => (
              <div key={product.id} className="px-2">
                <ProductCard product={product} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};
